import { useState } from 'react';
import { Tabs, Tab, useMediaQuery } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PERIOD_LABELS = ['Today', 'Weekly', 'Monthly', 'Yearly'];
const PERIOD_KEYS = ['today', 'weekly', 'monthly', 'yearly'];

// Theme built around #d63384
const CHART_COLORS = {
    Voice: '#60a5fa',   // primary
    Video: '#4ade80',   // lighter tint
    Chat: '#fbbf24',    // darker shade
};

const EngagementPieChart = ({ engagement }) => {
    const [tabIndex, setTabIndex] = useState(0);
    const isMobile = useMediaQuery('(max-width:600px)');

    if (!engagement) return null;

    const activeKey = PERIOD_KEYS[tabIndex];
    const activeData = engagement[activeKey];

    const chartData = activeData && Object.entries(activeData)
        .filter(([, value]) => value > 0)
        .map(([name, value]) => ({ name, value }));

    return (
        <div className="layout-item">
            <div className="layout-box widget-type2">
                <div className="widget-header">
                    <h2>User Engagement</h2>
                    <h4>View your user engagement metrics</h4>
                </div>

                <Tabs
                    value={tabIndex}
                    onChange={(e, newValue) => setTabIndex(newValue)}
                    variant="fullWidth"
                    TabIndicatorProps={{ style: { backgroundColor: '#d63384' } }}
                    sx={{
                        minHeight: 36,
                        mb: 1,
                        '& .MuiTab-root': {
                            minHeight: 36,
                            py: 0.5,
                            fontSize: isMobile ? '0.7rem' : '0.8125rem',
                            minWidth: 0,
                            px: isMobile ? 0.5 : 2,
                            color: '#fff',
                            '&.Mui-selected': { color: '#d63384', fontWeight: 600 },
                        },
                    }}
                >
                    {PERIOD_LABELS.map((label) => (
                        <Tab key={label} label={label} />
                    ))}
                </Tabs>

                <div className="widget-body">
                    {chartData.length > 0 ? (
                        <ResponsiveContainer width="100%" height={isMobile ? 220 : 280}>
                            <PieChart>
                                <Pie
                                    data={chartData}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={isMobile ? 45 : 60}
                                    outerRadius={isMobile ? 70 : 90}
                                    paddingAngle={2}
                                    label={!isMobile ? ({ name, value }) => `${name} ${value}%` : false}
                                    labelLine={!isMobile}
                                >
                                    {chartData.map((entry) => (
                                        <Cell
                                            key={entry.name}
                                            fill={CHART_COLORS[entry.name] || '#d63384'}
                                            stroke="#000"
                                            strokeWidth={1}
                                        />
                                    ))}
                                </Pie>
                                <Tooltip contentStyle={{ background: '#000', border: 'none', borderRadius: 8, fontSize: 12 }} formatter={(value) => `${value}%`} />
                                <Legend
                                    verticalAlign="bottom"
                                    height={24}
                                    iconSize={isMobile ? 8 : 10}
                                    wrapperStyle={{ fontSize: isMobile ? '0.7rem' : '0.8125rem' }}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    ) : (
                        <div className="no-data-placeholder">
                            No engagement data for this period
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EngagementPieChart;